import types from './types';

const setupToast = (data) => (
    {
        type: types.SET_TOAST,
        data
    }
);

const resetToast = (data) => (
    {
        type: types.RESET_TOAST,
        data
    }
);

export {
    setupToast,
    resetToast
};
